(function ($) {
    var $ = jQuery = $;


    if($('.collection-categories-wrapper').length > 0) {
        $('.collection-categories-wrapper').css({"top": ($('.header-container').outerHeight()) + "px"});
        $( window ).resize(function() {
            $('.collection-categories-wrapper').css({"top": ($('.header-container').outerHeight()) + "px"});
        });
    }


    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }


    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    if (getCookie('acceptCookiePolicy') !== "active") {
        $('#cookie-notice').show();
        $('#cn-accept-cookie, #cn-close-notice').on('click',function(e){
            e.preventDefault();
            setCookie('acceptCookiePolicy', 'active', 1);
            $('#cookie-notice').fadeOut();
            return false;
        });
    } else {
        $('#cookie-notice').hide();
    }


    if($('.collection-category-list li').length > 0) {

        let collectionCatList = $('.collection-category-list');
        let mainNav = $('.main-nav');
        let currentlyActiveSubNav = mainNav.find('.sub-nav-item.active');
        let currentlyActiveSubNavName = currentlyActiveSubNav.text().trim();
        let topLevelCatName = currentlyActiveSubNav.closest('li.nav-item').find('.nav-item-link-title').text().toLowerCase();

        collectionCatList.find('li[data-parent!="'+ topLevelCatName +'"]').hide();
        collectionCatList.find('li.collection-cat-title').show();
        $.each(collectionCatList.find('li[data-parent="'+ topLevelCatName +'"]'), function () {
            let catLink = $(this).find('a').text().trim();
            if(catLink === currentlyActiveSubNavName) {
                $(this).addClass("active");
            }
        });

        if(topLevelCatName === "face" || topLevelCatName === "body") {
            collectionCatList.find('li.always-show').hide();
        } else {
            collectionCatList.find('li.always-show').show();
        }


    }

    if($('.open-faq-modal').length > 0) {

        let faqModalContainer = $('.km-faq-pop-up-outer');
        let faqModalScrim = faqModalContainer.find('.km-scrim');
        let faqPopUp = faqModalContainer.find('.km-pop-up');
        let openModalBtn = $('.v3-product-faq .open-faq-modal');

        openModalBtn.on("click", function () {
            faqModalContainer.css({
                "display": "block",
                "z-index": "10002"
            });
            faqModalScrim.addClass("open");
            faqPopUp.addClass("open");
            document.addEventListener('click', closeFAQModal, true);
        });

        faqModalContainer.find('.km-close').on("click", function () {
            faqModalContainer.css({
                "display": "none",
                "z-index": "0"
            });
            faqModalScrim.removeClass("open");
            faqPopUp.removeClass("open");
        });


        let closeFAQModal= function (e) {

            let targetGroup = e ? $(e.target).parents().addBack() : null;

            if(targetGroup && targetGroup.is('.km-pop-up')) {
                if (targetGroup.is('.km-pop-up')) {
                    if (!targetGroup.is('a')) return;
                } else {
                    return;
                }
            }

            faqModalContainer.css({
                "display": "none",
                "z-index": "0"
            });
            faqModalScrim.removeClass("open");
            faqPopUp.removeClass("open");

            document.removeEventListener('click', closeFAQModal, true);

        };

    }

    if($('.v3-accordion-group').length > 0) {

        $('.v3-accordion-group').on("click", function () {

            let thisAccordion = $(this);
            let thisAccordionContainer = $(this).closest('.v3-content');

            thisAccordion.toggleClass("open");

            thisAccordionContainer.find('.v3-accordion-group').not($(this)).removeClass("open");

        });

    }

    if($('.faq-item, .treatment-item').length > 0) {

        $('.faq-item .faq-header, .treatment-item .treatment-header').on("click", function () {

            let thisClass = ($(this).hasClass("faq-header") === true) ? '.faq-item' : '.treatment-item';
            let thisFAQAccordionIndex = $(this).closest(thisClass).index();
            let thisFAQAccordion = $(this).closest(thisClass);
            let thisFAQAccordionContainer = ($(this).hasClass("faq-header") === true) ? $(this).closest('.faq-container') : $(this).closest('.treatment-container');

            thisFAQAccordion.toggleClass("open");

            thisFAQAccordionContainer.find(thisClass).not(':eq('+ thisFAQAccordionIndex +')').removeClass("open");

        });

    }

    $('#announcement-rotator').textRotator({
        random : false,
        fadeIn : 1000,
        fadeOut : 500,
        duration : 5000,
        easingin : 'swing',
        easingout : 'swing'
    });


    if($('.checkout-button').length > 0) {

        $('.checkout-button').on("click", function (e) {
            if($('#agree').prop("checked") === false) {
                e.preventDefault();
                e.stopPropagation();
                alert("You must agree to the terms and conditions before continuing");
                return false;
            }
        });

    }

    // -------------------------------------------------------
    // Free Gift-------------------------------------------
    // --

    let freeGift = function () {

        // Base vars
        let freeGiftEnabled = false;
        let giftThreshold = '99';
        let messageContainer = $('.km-message-gwp');
        let progressBar = $('#km-progress-bar-line');
        let GWPcontainer = $('#GWP-container');

        // Main functions
        const check = function(value) {

            // Update Progress Bar
            let width = Math.round(value / parseInt(giftThreshold) * 100) + '%';
            if(Math.round(value / parseInt(giftThreshold) * 100) > 100) {
                progressBar.width('100%');
            } else {
                progressBar.width(width);
            }

            // Check to see only the current GWP is in the cart
            $.getJSON('/cart.js', function(cart) {
                setTimeout(function (){
                    console.log(cart)
                // Cycle products in cart
                for(let i = 0; i < cart.items.length; i++ ) {
                    if(cart.items[i].title.indexOf("FREE GIFT") !== -1 && selectedProductID !== cart.items[i].product_id) {
                        // Remove this GWP from cart, it shouldn't be here
                        jQuery.post('/cart/update.js', {
                            updates: {
                                [cart.items[i].variant_id]: 0
                            },
                            success: function () {
                                console.log("Removed invalid GWP");
                            }
                        });
                    }
                }

                // Check if there's stock of the product
                if(selectedProductInventory) {

                    let productRoute = 'products/' + selectedProductHandle + '.js';
                    $.getJSON(window.Shopify.routes.root + productRoute, function(product) {


                        if(product.available) {

                            // Ensure GWP container is visible
                            if(GWPcontainer.is(":hidden")) {
                                GWPcontainer.fadeIn();
                            }

                            // Check current cart subtotal against threshold
                            if(value >= parseInt(giftThreshold)) {

                                // Update message
                                messageContainer.find(".is-false").hide();
                                messageContainer.find(".km-js-append-product-title").text(selectedProductTitle);
                                messageContainer.find(".is-true").show();

                                // Add gift to cart, if not already
                                addFreeGift();

                            } else {

                                // Calculate difference between threshold and cart value
                                let giftDifference = parseFloat(parseInt(giftThreshold) - value).toFixed(2);

                                // Update message
                                messageContainer.find(".is-true").hide();
                                messageContainer.find(".km-js-append-product-title").text(selectedProductTitle);
                                messageContainer.find('.km-diff').text("$" + giftDifference);
                                messageContainer.find(".is-false").show();


                                // Remove gift from cart, if not already
                                removeFreeGift();
                            }

                        } else {

                            // Remove gift from cart, if not already
                            removeFreeGift();

                            // Hide gift container
                            GWPcontainer.hide();
                        }

                    });


                } else {

                    // Ensure GWP container is visible
                    if(GWPcontainer.is(":hidden")) {
                        GWPcontainer.fadeIn();
                    }

                    // Check current cart subtotal against threshold
                    if(value >= parseInt(giftThreshold)) {

                        // Update message
                        messageContainer.find(".is-false").hide();
                        messageContainer.find(".km-js-append-product-title").text(selectedProductTitle);
                        messageContainer.find(".is-true").show();

                        // Add gift to cart, if not already
                        addFreeGift();

                    } else {

                        // Calculate difference between threshold and cart value
                        let giftDifference = (parseInt(giftThreshold) - value);

                        // Update message
                        messageContainer.find(".is-true").hide();
                        messageContainer.find(".km-js-append-product-title").text(selectedProductTitle);
                        messageContainer.find('.km-diff').text("$" + giftDifference);
                        messageContainer.find(".is-false").show();


                        // Remove gift from cart, if not already
                        removeFreeGift();
                    }

                } // End check if inventory tracking is enabled

                }, 1000)
            });


        }

        const addFreeGift = function () {

            // Base vars
            let alreadyAdded = false;
            let GWPquantity = 0;

            // Check if already added
            $.getJSON('/cart.js', function(cart){

                // Cycle products in cart
                for(let i = 0; i < cart.items.length; i++ ) {
                    if(selectedProductID === cart.items[i].product_id) {
                        alreadyAdded = true;
                        GWPquantity = cart.items[i].quantity;
                    }
                }

                // Check quantity, and ensure it stays at a max of 1
                if(alreadyAdded === true && GWPquantity > 1) {

                    jQuery.post('/cart/update.js', {
                        updates: {
                            [selectedProductVariantID]: 1
                        },
                        success: function () {
                            setTimeout(function(){
                                location.reload();
                            }, 250);
                        }
                    });

                }

                // Go ahead and add free gift
                if(alreadyAdded === false) {

                    jQuery.post('/cart/add.js', {
                        quantity: 1,
                        id: selectedProductVariantID,
                        success: function () {
                            setTimeout(function(){
                                location.reload();
                            }, 250);
                        }
                    });

                }

            });

        }

        // Remove gift
        const removeFreeGift = function() {

            // Base vars
            let alreadyAdded = false;

            // Check if already added
            $.getJSON('/cart.js', function(cart){

                // Cycle products in cart
                for(let i = 0; i < cart.items.length; i++ ) {
                    if(selectedProductID === cart.items[i].product_id) {
                        alreadyAdded = true;
                    }
                }

                // Go ahead and remove free gift
                if(alreadyAdded === true) {

                    //console.log("removing");

                    jQuery.post('/cart/update.js', {
                        updates: {
                            [selectedProductVariantID]: 0
                        },
                        success: function () {
                            setTimeout(function(){
                                location.reload();
                            }, 250);
                        }
                    });

                }

            });

        }

        // Init the free gift function on cart page, if enabled
        if(freeGiftEnabled) {

            // Obtain cart value
            $.getJSON('/cart.js', function(cartData) {
                let cartSubtotal = (cartData.items_subtotal_price / 100);
                check(cartSubtotal);
            });

            // Listen for cart update event, and re-calculate applicability for free gift item
            document.addEventListener('theme:cartchanged', function (e) {
                setTimeout(function() {
                    $.getJSON('/cart.js', function(cart){

                        // Base vars
                        let goal = 75;
                        const currentTotal = (cart.items_subtotal_price / 100);

                        // Check if threshold reached for free item
                        check(currentTotal);


                        // Free shipping
                        if (currentTotal >= parseInt(goal)) {
                            $('.km-free-shipping-text').html('You got free shipping!');
                            $('.km-free-shipping').addClass('km-free')
                        } else {
                            $('.km-free-shipping-text').html('Spend $' + (parseInt(goal) - currentTotal).toFixed(2) + ' more and get free shipping');
                            $('.km-free-shipping').removeClass('km-free')
                        }

                    })
                }, 400);
            }, false);

        }



    }

    // Call the freeGift function when cart page is visible
    if ($('body').hasClass("template-cart")) {

        // Free gift
        let freeGiftEnabled = false;
        if(freeGiftEnabled) {
            freeGift();
        }

        // Free shipping
        var goal = 75;
        var cartSubtotal = 0;

        $.getJSON('/cart.js', function(cartData) {
            cartSubtotal = (cartData.items_subtotal_price / 100);

            if (cartSubtotal >= parseInt(goal)) {
                $('.km-free-shipping-text').html('You got free shipping!');
                $('.km-free-shipping').addClass('km-free')
            } else {
                $('.km-free-shipping-text').html('Spend $' + (parseInt(goal) - cartSubtotal).toFixed(2) + ' more and get free shipping');
                $('.km-free-shipping').removeClass('km-free')
            }
        });


        // Listen for cart update event, and re-calculate applicability for free gift item
        document.addEventListener('theme:cartchanged', function (e) {
            setTimeout(function() {
                $.getJSON('/cart.js', function(cart){

                    // Base vars
                    let goal = 75;
                    const currentTotal = (cart.items_subtotal_price / 100);
                    console.log(currentTotal, 'current')
                    // Free shipping
                    if (currentTotal >= parseInt(goal)) {
                        $('.km-free-shipping-text').html('You got free shipping!');
                        $('.km-free-shipping').addClass('km-free')
                    } else {
                        $('.km-free-shipping-text').html('Spend $' + (parseInt(goal) - currentTotal).toFixed(2) + ' more and get free shipping');
                        $('.km-free-shipping').removeClass('km-free')
                    }

                })
            }, 1400);
        }, false);

    }

    // Subscription Preferences page
    if($('body').hasClass("template-sfx-newsletter-preferences")) {

        $.urlParam = function(name){
            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
            if (results==null) {
                return null;
            }
            return decodeURI(results[1]) || 0;
        }

        var displayMessage = function(targetForm, type, message, delay) {

            switch(type) {

                case "error":
                    // Display error notification
                    targetForm.find(".ajax-response").empty();
                    targetForm.find(".ajax-response").html('<notification class="notification notification--error">'+ message +'</notification>');
                    targetForm.find(".ajax-response").show().delay(delay).fadeOut(500);
                    break;


                case "success":
                    // Display success notification
                    targetForm.find(".ajax-response").empty();
                    targetForm.find(".ajax-response").html('<notification class="notification notification--success">'+ message +'</notification>');
                    targetForm.find(".ajax-response").show().delay(delay).fadeOut(500);
                    break;
            }

        }

        document.addEventListener("DOMContentLoaded", function() {

            // Base vars
            let targetForm = $('#submit-subscription-preferences');
            let submitBtn =  $('#contactFormSubmit');
            let suggestedEmail = $.urlParam("email");

            // Disable submit button initially
            submitBtn.prop("disabled", true);


            // Setup basic form input controls
            $('.frequency-checkbox').on("click", function () {
                $('.frequency-checkbox').prop('checked', false);
                $(this).prop('checked', true);
                if($(this).attr('name') === "frequency['unsubscribe']") {
                    submitBtn.val("Unsubscribe");
                } else {
                    submitBtn.val("Update Preferences");
                }
            });
            $('.contactmethod-checkbox').on("click", function () {
                $('.contactmethod-checkbox').prop('checked', false);
                $(this).prop('checked', true);
                if($(this).attr('name') === "contactmethod[both]" || $(this).attr('name') === "contactmethod[sms]") {
                    $('input[name="phone_number"]').attr("placeholder", "Phone*");
                } else {
                    $('input[name="phone_number"]').attr("placeholder", "Phone");
                }
            });
            if($('.contactmethod-checkbox').attr('name') === "contactmethod[both]" || $('.contactmethod-checkbox').attr('name') === "contactmethod[sms]") {
                $('input[name="phone_number"]').attr("placeholder", "Phone*");
            } else {
                $('input[name="phone_number"]').attr("placeholder", "Phone");
            }


            // Fetch userID
            if(suggestedEmail !== 'undefined' && suggestedEmail !== null) {

                // Submit data
                $.ajax({
                     url: 'https://dev.efluxdesign.com/onelove/klaviyo-user-preferences.php',
                     data: {search: "customerID", formData: suggestedEmail},
                     type: 'POST',
                     dataType: 'JSON'
                 }).done(function(response) {

                    console.log("Response: " + response);

                    if(response.status === 200 && response.data !== null) {

                        // Enable form and fill out defaults
                        submitBtn.prop("disabled", false);

                        targetForm.find('input[name="userEmail"]').val(response.data.email);
                        targetForm.find('input[name="id"]').val(response.data.id);
                        targetForm.find('input[name="contactmethod['+ response.data.contact_method +']"]').prop("checked", true);

                        if(response.data.accepts_marketing == false) {
                            targetForm.find('input[name="frequency[unsubscribe]"]').prop("checked", true);
                        } else {
                            targetForm.find('input[name="frequency['+ response.data.contact_frequency +']"]').prop("checked", true);
                        }

                        $.each(response.data.customer_interest, function( index, value ) {
                            targetForm.find('input[name="customerinterest['+ value +']"]').prop("checked", true);
                        });

                    } else {
                        displayMessage(targetForm, "error", "User not found", 5000);
                    }

                 }).fail(function (jQueryXHR, e) {

                     // Server level errors
                     let errorMsg;

                     if (jQueryXHR.status === 0) {
                         errorMsg = "Too many requests. Please wait a few seconds before attempting to re-submit.";
                     } else if (jQueryXHR.status === 404) {
                         errorMsg = "Requested URL not found.";
                     } else if (jQueryXHR.status === 500) {
                         errorMsg = "Internal server error";
                     } else if (e === 'parsererror') {
                         errorMsg = jQueryXHR.responseText;
                     } else if (e === 'timeout') {
                         errorMsg = "Request Timed Out";
                     } else {
                         errorMsg = "Unknown Error.";
                     }

                     // Output error
                   //console.log(errorMsg);
                    displayMessage(targetForm, "error", errorMsg, 5000);

                 }).then(function() {

                     // Continue ...
                    submitBtn.on("click.submitForm", function (e) {
                        e.preventDefault();
                        if($(this).attr('disabled')) return false;
                        submitBtn.prop("disabled", true);

                        // Serialize form
                        let formData = targetForm.serialize();

                        // Process checkboxes
                        targetForm.find('input[type="checkbox"]').each(function() {
                            if( $(this).prop("checked") ) {
                                formData += "&" + $(this).attr("name") + "=" + "1";
                            } else {
                                formData += "&" + $(this).attr("name") + "=" + "0";
                            }
                        });

                        // Submit data
                        $.ajax({
                            url: 'https://dev.efluxdesign.com/onelove/klaviyo-user-preferences.php',
                            data: {search: "updatePreferences", formData: formData},
                            type: 'POST',
                            dataType: 'JSON'
                        }).done(function(customerData) {

                            //console.log(customerData);
                            submitBtn.prop("disabled", false);

                            if(customerData.status !== "200") {
                                if(customerData.status == "404") {
                                    displayMessage(targetForm, "error", customerData.data.detail, 5000);
                                } else {
                                    displayMessage(targetForm, "error", customerData.error, 5000);
                                }
                            } else {
                                if(customerData.data !== 'undefined' && customerData.data !== null) {
                                    displayMessage(targetForm, "success", "Subscription Preferences Updated", 5000);
                                } else {
                                    displayMessage(targetForm, "success", "Unsubscribed. We're sorry to see you go!", 5000);
                                }

                            }

                        }).fail(function (jQueryXHR, e) {

                            // Server level errors
                            let errorMsg;

                            if (jQueryXHR.status === 0) {
                                errorMsg = "Too many requests. Please wait a few seconds before attempting to re-submit.";
                            } else if (jQueryXHR.status === 404) {
                                errorMsg = "Requested URL not found.";
                            } else if (jQueryXHR.status === 500) {
                                errorMsg = "Internal server error";
                            } else if (e === 'parsererror') {
                                errorMsg = jQueryXHR.responseText;
                            } else if (e === 'timeout') {
                                errorMsg = "Request Timed Out";
                            } else {
                                errorMsg = "Unknown Error.";
                            }

                            // Output error
                            displayMessage(targetForm, "error", errorMsg, 5000);

                        }).then(function(data) {

                            // Done ...


                        });

                    });

                 });


            } else {

                // Output error message and disable submit button
                displayMessage(targetForm, "error", "No active user found. Please load this preferences page directly through the link provided in any authorized One Love Organics marketing communications.", 10000);
            }



            


        });
    }

    $(document).ready(function() {
        $('.km-agree-error').removeClass('visible');
    });

    $(document).on("click", ".cart-summary__buttons .btn", function(e) {
        if($('.km-agree--drawer').length > 0) {
            if($('.km-agree--drawer input[type="checkbox"]').prop("checked") === false) {
                e.preventDefault();
                e.stopPropagation();
                $('.km-agree-error').addClass('visible');
                return false;
            }
        }
    });

    $(document).on("change", ".km-agree--drawer input[type='checkbox']", function() {
        if($(this).prop("checked")) {
            $('.km-agree-error').removeClass('visible');
            $('.cart-summary__buttons .disabledBtn').css('display', 'none');
            $('.cart-summary__buttons .btn.wide.hide').css('display', 'block');
        } else {
            $('.cart-summary__buttons .btn.wide.hide').css('display', 'none');
            $('.cart-summary__buttons .disabledBtn').css('display', 'block');
        }
    });

})(jQuery);